<form #databaseForm="ngForm" class="mt-20">
  <div>
    <div class="security-category">
      <!-- Data Model -->
      <h5 name="provider">{{locale.LABEL_DATABASE}} {{locale.LABEL_CONFIGURATION}}</h5>
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 required" for="wm-security-db-model">{{locale.LABEL_DATABASE}}:
        </label>
        <div class="col-xs-9">
          <select id="wm-security-db-model" name="wm-security-db-model" (change)="setTableEntities()"
            class="form-control app-select" [(ngModel)]="security.modelName">
            <option *ngFor="let option of security.dataModels" [ngValue]="option">
              {{option}}
            </option>
          </select>
        </div>
      </div>
      <!-- Entity -->
      <div *ngIf="security.showUnamePass || security.provider.value === 'Database'">
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 required"
          for="wm-security-db-entity">{{locale.LABEL_USER_TABLE}}: </label>
        <div class="col-xs-9">
          <wms-typeahead name="wm-security-db-entity" placeholder="{{locale.LABEL_SEARCH_USER_TABLE}}"
            [model]="security.tableName" [options]="security.entities" (onSelect)="setFields($event)"
            (onClear)="onTableNameClear()"></wms-typeahead>
        </div>
      </div>
      <hr >
    </div>
    </div>

    <div class="security-category" *ngIf="security.showUnamePass || security.provider.value === 'Database'">
      <h5 name="user">{{locale.LABEL_USER}}</h5>

      <!-- Userid Field -->
        <!-- Userid Field -->
        <div class="form-group app-composite-widget clearfix">
          <label class="control-label app-label col-xs-3 required">{{locale.LABEL_USERID_COLUMN}}: </label>
          <div class="col-xs-9">
            <wms-typeahead name="wm-security-db-userid" placeholder="{{locale.LABEL_SEARCH_USER_ID}}"
              (onSelect)="security.uidPropertyName = $event.value;makeFormDirty('uidPropertyName', $event.value)" [model]="security.uidPropertyName"
              [options]="security.tableFields" (onClear)="makeFormDirty('uidPropertyName', $event)"></wms-typeahead>
          </div>
      </div>
      <!-- Username Field -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 required"
          for="wm-security-db-username">{{locale.LABEL_USERNAME_COLUMN}}: </label>
        <div class="col-xs-9">
          <wms-typeahead name="wm-security-db-username" placeholder="{{locale.LABEL_SEARCH_USER_NAME}}"
            [model]="security.unamePropertyName" [options]="security.tableFields"
            (onSelect)="security.unamePropertyName = $event.value;makeFormDirty('unamePropertyName', $event.value); populateRolesQuery(true)" (onClear)="makeFormDirty('unamePropertyName', $event)"></wms-typeahead>
        </div>
      </div>
        <!-- Password -->
        <div class="form-group app-composite-widget clearfix">
          <label class="control-label app-label col-xs-3 required"
            for="wm-security-db-password">{{locale.LABEL_PASSWORD_COLUMN}}: </label>
          <div class="col-xs-9">
            <wms-typeahead name="wm-security-db-password" placeholder="{{locale.LABEL_SEARCH_USER_PASSWORD}}"
              [model]="security.pwPropertyName" [options]="security.tableFields"
              (onSelect)="security.pwPropertyName = $event.value;makeFormDirty('pwPropertyName', $event.value);" (onClear)="makeFormDirty('pwPropertyName', $event)"></wms-typeahead>
          </div>
        </div>
      <hr >
    </div>

    <div class="security-category">
      <h5 name="role" *ngIf="security.showUnamePass || security.provider.value === 'Database'">{{locale.LABEL_ROLE}}</h5>

      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3" >{{locale.LABEL_ROLE_CONFIGURATION}}: </label>
        <wms-toggle id="role-configuration-toggle-db" class="ml-15" name="role-configuration-toggle-db" [model]="security.roleConfig" [onValue]="'BASIC'"
          [offValue]="'CUSTOM'" [onLabel]="locale.LABEL_BASIC" [offLabel]="locale.LABEL_CUSTOM" customClasses="switch"
          (onChange)="onRoleConfigChange($event)"></wms-toggle>
      </div>
      <div *ngIf="security.roleConfig === 'BASIC'">
        <!-- User Table -->
        <div class="form-group app-composite-widget clearfix" *ngIf="security.provider.value !== 'Database'">
          <label class="control-label app-label col-xs-3 required"
            for="wm-security-db-entity">{{locale.LABEL_USER_TABLE}}: </label>
          <div class="col-xs-9">
            <wms-typeahead name="wm-security-db-entity" placeholder="{{locale.LABEL_SEARCH_USER_TABLE}}"
              [model]="security.tableName" [options]="security.entities" (onSelect)="setFields($event)"
              (onClear)="onTableNameClear()"></wms-typeahead>
          </div>
        </div>
        <!-- Username Column -->
        <div class="form-group app-composite-widget clearfix" *ngIf="security.provider.value !== 'Database'">
          <label class="control-label app-label col-xs-3 required"
            for="wm-security-db-username">{{locale.LABEL_USERNAME_COLUMN}}: </label>
          <div class="col-xs-9">
            <wms-typeahead name="wm-security-db-username" placeholder="{{locale.LABEL_SEARCH_USER_NAME}}"
              [model]="security.unamePropertyName" [options]="security.tableFields"
              (onSelect)="security.unamePropertyName = $event.value; populateRolesQuery(true)" (onClear)="makeFormDirty('unamePropertyName', $event)"></wms-typeahead>
          </div>
        </div>
        <!-- Role -->
        <div class="form-group app-composite-widget clearfix">
          <label class="control-label app-label col-xs-3" for="wm-security-db-role">{{locale.LABEL_ROLE_COLUMN}}:
          </label>
          <div class="col-xs-9">
            <wms-typeahead name="wm-security-db-role" placeholder="{{locale.LABEL_SEARCH_USER_ROLE}}"
              [model]="security.rolePropertyName" [options]="security.tableFields"
              (onSelect)="security.rolePropertyName = $event.value; populateRolesQuery();" (onClear)="makeFormDirty('rolePropertyName', $event)"></wms-typeahead>
          </div>
        </div>
      </div>

      <!-- Enter Query -->
      <div class="form-group app-composite-widget clearfix" *ngIf="security.roleConfig === 'CUSTOM'">
        <label class="control-label app-label col-xs-3">{{locale.LABEL_DATABASE_QUERY_TYPE}}: </label>
        <wms-toggle id="wm-query-type-toggle" class="ml-15" name="wm-query-type" [model]="security.queryType" [onValue]="'NATIVE_SQL'"
          [offValue]="'HQL'" [onLabel]="'SQL'" [offLabel]="'HQL'" customClasses="switch"
          (onChange)="onToggle($event)"></wms-toggle>
      </div>
      <div class="code-editor clearfix">
        <div class="form-group col-xs-offset-3 col-xs-9 wm-code-editor-container">
          <div *ngIf="security.roleConfig === 'CUSTOM'">
            <p class="text-muted">{{locale.LABEL_QUERY_TYPES_MESSAGE}}</p>
            <p class="query-message text-muted">Enter a {{security.queryType}} query which returns username and provide
              username to test the query</p>
          </div>
          <wms-editor [ngClass]="{'hidden': security.roleConfig === 'BASIC'}" name="wm-query-editor" [customClasses]="'wm-code-editor-view'" [options]="editorOptions" (onChange)="onExprChange()" #codeEditor></wms-editor>
        </div>
        <div class="col-xs-offset-3 col-xs-9" *ngIf="security.roleConfig === 'CUSTOM'">
          <div class="form-group app-composite-widget clearfix">
            <label class="control-label app-label col-xs-2">{{locale.LABEL_USER_NAME}}</label>
            <div class="col-xs-4 security-username-container">
              <input name="user-id" type="text" class="form-control app-textbox" [(ngModel)]="security.userName" />
            </div>
            <div class="col-xs-3 test-query-container">
              <button name="wm-security-test-query" (click)="testQuery()"
                class="button-primary">{{locale.LABEL_TEST_QUERY}}</button>
            </div>
          </div>

          <div class="form-group app-composite-widget clearfix">
            <div class="col-xs-12">
              <div class="no-roles-info" *ngIf="security.sqlQueryRoles?.length === 0">
                {{locale.LABEL_NO_ROLES_FOUND}}
              </div>
              <div class="list-table roles-by-sqlquery" *ngIf="security.sqlQueryRoles?.length > 0">
                <table class="wm-table">
                  <tbody>
                    <tr>
                      <th *ngFor="let role of security.sqlQueryRoles[0] | keyvalue">{{role.key}}</th>
                    </tr>
                    <tr *ngFor="let sqlRole of security.sqlQueryRoles">
                      <td name="wm-security-role-output" *ngFor="let item of sqlRole | keyvalue">{{item.value}} </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
